import { simpleModelReducer } from "redux-server-connection";

export default {
  users: simpleModelReducer("users"),
  points: simpleModelReducer("points"),
  categories: simpleModelReducer("categories"),
  products: simpleModelReducer("products"),
  trainings: simpleModelReducer("trainings"),
  trivias: simpleModelReducer("trivias"),
  goals: simpleModelReducer("goals"),
  avatars: simpleModelReducer("avatars"),
  ranking: simpleModelReducer("ranking")
};



// WEBPACK FOOTER //
// ./src/reducers/reducers.js